import { ActionPayload } from "@/utils/types/userPreferencesGrid";

export default class UserPreferencesService {
  static addUserPreferencesGrid = async (
    _payload: ActionPayload
  ): Promise<void> => {
    // user-preferences-general API is not available
  };

  static getUserPreferencesGrid = async (): Promise<[]> => {
    return [];
  };
}
